<template>
  <div class="no-skin">
  <div id="navbar" class="navbar navbar-default ace-save-state" v-bind:class="{'red-background': checkEnv()}">
    <div class="navbar-container ace-save-state" id="navbar-container">
      <button type="button" class="navbar-toggle menu-toggler pull-left" id="menu-toggler" data-target="#sidebar">
        <span class="sr-only">Toggle sidebar</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <div class="navbar-header pull-left">
        <a href="/" class="navbar-brand">
          <img :src="logo" alt="logo" />
        </a>
      </div>
      <div class="navbar-buttons navbar-header pull-right" role="navigation">
        <ul class="nav ace-nav">
          <li>
            <a data-toggle="dropdown" href="#" class="dropdown-toggle">
              <i v-if="error" class="menu-icon fa fa-user custom-acount-icon"></i>
              <img  v-else class="nav-user-photo" id="avatar-menu-top" src="" alt="avatar">
              <span class="user-info">
                {{ profile.userName }}
              </span>
              <i class="ace-icon fa fa-caret-down"></i>
            </a>
            <ul class="user-menu dropdown-menu-right dropdown-menu dropdown-yellow dropdown-caret dropdown-close">
              <li>
                <a href="#my-modal-profile" data-toggle="modal">プロフィール</a>
              </li>
              <router-link tag="li" :to="{ name: 'userchangepassword'}">
                <a>パスワード変更</a>
              </router-link>
              <router-link tag="li" :to="{ name: 'user-configuration'}">
                <a>設定</a>
              </router-link>
              <li>
                <a href="javascript:void(0)" @click="logout()">サインアウト</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="pull-right">
          <a class="btn-cusstom pull-right btn-support" href="https://support.alligate.me/hc/ja" target="_blank"><i class="fa fa-question-circle"></i> <br>ヘルプ</a>
      </div>
    </div><!-- /.navbar-container -->
  </div>
  <div class="main-container ace-save-state" id="main-container">
    <div id="sidebar" class="sidebar responsive ace-save-state">
      <ul class="nav nav-list">
        <router-link tag="li" :to="{ name: 'dashboard'}">
          <a id="sideDashboardLink">
            <i class="menu-icon fa fa-tachometer"></i>
            <span class="menu-text">メインメニュー</span>
          </a>
        </router-link>
        <router-link tag="li" :to="{ name: 'process-user-register'}" active-class="active" v-if="isAdmin === 'true'">
          <a id="sideExcelsLink">
            <!-- <i class="menu-icon fa fa-user"></i> -->
            <i class="menu-icon fa fa-share-alt"></i>
            <span class="menu-text">ユーザー一括登録</span>
          </a>
        </router-link>
        <router-link tag="li" :to="{ name: 'user'}" active-class="active"  v-if="isAdmin === 'true'">
          <a id="sideUsersLink">
            <i class="menu-icon fa fa-user"></i>
            <span class="menu-text">ユーザー</span>
          </a>
        </router-link>
        <router-link tag="li" :to="{ name: 'gates'}" active-class="active" v-if="isAdmin === 'true'">
          <a id="sideGatesLink">
            <i class="menu-icon glyphicon glyphicon-log-in"></i>
            <span class="menu-text">ゲート</span>
          </a>
        </router-link>
        <router-link tag="li" :to="{ name: 'group'}" active-class="active" v-if="isAdmin === 'true'">
          <a id="sideGroupsLink">
            <i class="menu-icon fa fa-users"></i>
            <span class="menu-text">ゲートグループ</span>
          </a>
        </router-link>
        <router-link tag="li" :to="{ name: 'pcode'}" active-class="active" v-if="isAdmin === 'true'">
          <a id="sidePcodeLink">
            <i class="menu-icon fa fa-credit-card "></i>
            <span class="menu-text">個人コード</span>
          </a>
        </router-link>
        <router-link tag="li" :to="{ name: 'phones'}" active-class="active" v-if="isAdmin === 'true'">
          <a id="sidePhonesLink">
            <i class="menu-icon glyphicon glyphicon-phone"></i>
            <span class="menu-text">スマートフォン</span>
          </a>
        </router-link>
        <router-link tag="li" :to="{ name: 'logs'}" active-class="active">
          <a id="sideLogsLink">
            <i class="menu-icon glyphicon glyphicon-list"></i>
            <span class="menu-text">ログ情報</span>
          </a>
        </router-link>
        <router-link tag="li" :to="{ name: 'setting'}" v-on:click.native = "goSetting" active-class="active" v-if="isAdmin === 'true'" >
          <a id="sideSettingLink" >
            <i class="menu-icon glyphicon glyphicon-cog"></i>
            <span class="menu-text">システム設定</span>
          </a>
        </router-link>
        <router-link tag="li" :to="{ name: 'keyadd'}" active-class="active" v-if="isAdmin === 'true'">
          <a id="sideKeyaddLink">
            <i class="menu-icon glyphicon glyphicon-check"></i>
            <span class="menu-text">鍵共有</span>
          </a>
        </router-link>
        <router-link tag="li" :to="{ name: 'export'}" active-class="active" v-if="isAdmin === 'true'">
          <a id="sideExportLink">
            <i class="menu-icon fa fa-share"></i>
            <span class="menu-text">CSVエクスポート</span>
          </a>
        </router-link>
      </ul><!-- /.nav-list -->

      <div class="sidebar-toggle sidebar-collapse" id="sidebar-collapse">
        <i id="sidebar-toggle-icon" class="ace-icon fa fa-angle-double-left ace-save-state" data-icon1="ace-icon fa fa-angle-double-left" data-icon2="ace-icon fa fa-angle-double-right"></i>
      </div>
    </div>

    <div class="main-content">
      <div class="main-content-inner">
        <router-view></router-view>
      </div>
    </div><!-- /.main-content -->

    <div class="footer">
      <div class="footer-inner">
        <div class="footer-content">
          <span class="bigger-120">
            <span class="blue bolder">{{ corporateName }}</span>
          </span>
        </div>
      </div>
    </div>
    <a href="#" id="btn-scroll-up" class="btn-scroll-up btn btn-sm btn-inverse">
      <i class="ace-icon fa fa-angle-double-up icon-only bigger-110"></i>
    </a>
    <!-- プロフィールModal -->
    <div id="my-modal-profile" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h3 class="smaller lighter frofile-title no-margin">プロフィール</h3>
          </div>
          <div class="modal-body">
            <div class="alert alert-danger" v-if="error">
              {{ error }}
            </div>
            <div id="user-profile-1" class="user-profile row">
              <div class="col-xs-12 col-sm-4 center">
                <span class="profile-picture">
                  <img id="avatar" class="editable img-responsive" alt="User's Avatar" src="" />
                </span>
              </div>
              <div class="col-xs-12 col-sm-8">
                <div class="profile-user-info profile-user-info-striped">
                  <div class="profile-info-row">
                    <div class="profile-info-name">事業者ID:</div>
                    <div class="profile-info-value">
                      <span class="editable editable-click" id="ownerid">{{ profile.ownerId }}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ユーザーID:</div>
                    <div class="profile-info-value">
                      <span class="editable editable-click" id="userid">{{ profile.userId }}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ユーザー名:</div>
                    <div class="profile-info-value">
                      <span class="editable editable-click" id="kanji">{{ profile.userName }}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ふりがな:</div>
                    <div class="profile-info-value">
                      <span class="editable editable-click" id="furigana">{{ profile.furigana }}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">メールアドレス:</div>
                    <div class="profile-info-value">
                      <span class="editable editable-click" id="email">{{ profile.email }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-danger pull-right" data-dismiss="modal">
              閉じる
            </button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
  </div><!-- /.main-container -->
  </div>
</template>
<style>
  .modal-header h3.frofile-title{
    color: #007F41;
    font-weight: bold;
  }
  .modal-dialog {
    position: relative;
    margin: 0 auto;
    top: 25%;
  }
  .ace-nav .nav-user-photo {
    border: 1px solid #ddd
  }
  .fa-caret-down {
    font-size: 20px!important;
  }
  .red-background{
    background:#ff6666
  }
  .btn-support {
    margin: 14px;
    color: #000;
    text-align: center;
    margin: 0px 35px;
    margin-top: 4px;
    color: #000;
    text-align: center;
  }
  .btn-support:hover,.btn-support:active{
    color: #000;
  }
  .btn-support i {
    margin-right: 5px;
    margin-top: -5px;
    font-size: 32px;
  }
</style>
<script>
import * as Config from '../config'
export default {
  name: 'dashboard',
  data () {
    return {
      env: process.env.NODE_ENV,
      logo: process.env.LOGO_IMAGE,
      corporateName: process.env.CORPORATE_NAME,
      profile: {
        ownerId: '',
        userId: '',
        userName: '',
        furigana: '',
        email: '',
        thumbnail: ''
      },
      isAdmin: 'false',
      shareKeyBeValid: 'false',
      isMfa: 'false',
      isFederatedLoginService: 'false',
      error: ''
    }
  },
  // created () {
  //   if (window.localStorage) {
  //     if (!localStorage.getItem('firstLoad')) {
  //       localStorage['firstLoad'] = true
  //       window.location.reload()
  //     }
  //   }
  // },

  computed: {
    // currentRouteName () {
    //   return this.$route.name
    // }
  },
  mounted () {
    var vm = this
    vm.getProfile()
    vm.getPlan()
  },
  methods: {
    checkEnv () {
      if (this.env === 'staging1' || this.env === 'development') {
        return true
      } else {
        return false
      }
    },
    getProfile () {
      this.$http.get(Config.USERS_LIST_API + '?userId=' + encodeURIComponent(localStorage.userProfileId))
        .then(response => {
          localStorage.setItem('ownerId', response.body.users[0].owner.ownerId)
          localStorage.setItem('isAdmin', response.body.users[0].isAdmin)
          localStorage.setItem('shareKeyBeValid', response.body.users[0].shareKeyBeValid)
          this.isAdmin = localStorage.isAdmin
          this.shareKeyBeValid = localStorage.shareKeyBeValid
          this.profile.ownerId = response.body.users[0].owner.ownerId
          this.profile.userId = response.body.users[0].userId
          this.profile.userName = response.body.users[0].name
          this.profile.furigana = response.body.users[0].furigana
          this.profile.email = response.body.users[0].email
          this.profile.thumbnail = response.body.users[0].thumbnail
          document.getElementById('avatar').setAttribute(
            'src', 'data:image/png;base64,' + response.body.users[0].thumbnail
          )
          document.getElementById('avatar-menu-top').setAttribute(
            'src', 'data:image/png;base64,' + response.body.users[0].thumbnail
          )
        })
        .catch((error) => {
          if (error.body) {
            switch (error.status) {
              case 401:
                if (error.body.message === 'The incoming token has expired') {
                  this.error = ''
                } else {
                  this.error = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                }
                break
              case 400:
                this.error = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                break
              case 403:
                this.error = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
              case 404:
                this.error = '該当するデーターがありません。'
                break
              case 500:
                this.error = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              case 503:
                this.error = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              default:
                this.error = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
            }
          } else {
            this.error = Config.SERVER_CONNECT_ERROR
          }
        })
    },
    getPlan () {
      var checkIsExternalLogin = localStorage.isExternalLogin
      if (checkIsExternalLogin === '' || checkIsExternalLogin === null || checkIsExternalLogin === undefined) {
        localStorage.setItem('isExternalLogin', 'setting')
      }
      localStorage.setItem('isMfa', false)
      localStorage.setItem('isFederatedLoginService', false)
      this.$http.get(Config.PLAN_API)
        .then((response) => {
          if (response.body.maxRecords > 0) {
            localStorage.setItem('isMfa', response.body.plans[0].isMfa)
            localStorage.setItem('isFederatedLoginService', response.body.plans[0].isFederatedLoginService)
            this.isMfa = localStorage.isMfa
            this.isFederatedLoginService = localStorage.isFederatedLoginService
          }
        }).catch((error) => {
          console.log(error)
        })
    },
    logout () {
      this.$auth.logout()
    },
    async goSetting (e) {
      e.preventDefault()
      var activeTab = localStorage.activeTab
      var go = $('#go-setting').attr('class')
      if (go !== undefined && activeTab === 'setting5') {
        $('#go-setting').trigger('click')
      } else {
        if (this.$route.path !== '/setting') {
          this.$router.push({name: 'setting'})
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Layout.vue